import React from 'react';
import PropTypes from 'prop-types';
import { RevisorProvider } from '@weezevent/revisor-front';
import { fetcher } from '@weezevent/weezjs-core';
import { usePermissions } from '../user/permissions';

// Adapter: weezjs-core fetcher returns { response }, but revisor-front reads { data }.
// Revision lists come back paginated ({ data: [...] }) and are unwrapped to the array;
// user-name lookups return a single record, which is passed through as-is.
const revisionsFetcher = {
    get: (url, options) =>
        fetcher.get(url, { ...options, allow_cache: false, cache: false }).then(({ response }) => ({
            data: Array.isArray(response?.data) ? response.data : response
        }))
};

export const RevisorProviderWrapper = ({ children }) => {
    const permissions = usePermissions();

    return (
        <RevisorProvider baseUrl={window.weezConfig.api.apiUrl} fetcher={revisionsFetcher} isAdmin={() => permissions.isAdmin()} classNames={{ panel: 'willy-revisor-panel' }}>
            {children}
        </RevisorProvider>
    );
};

RevisorProviderWrapper.propTypes = {
    children: PropTypes.node
};
